import React from 'react';
import { Box, Typography } from '@mui/material';
import TalentPoolApplicationsTable from './TalentPoolApplicationsTable';

/**
 * TalentPool-hakemusten hallintanäkymä
 * Näyttää otsikon ja taulukon kaikista hakemuksista
 */
const TalentPoolApplications = () => {
	return (
		<Box sx={{ p: 3 }}>
			<Typography variant="h4" gutterBottom>
				TalentPool-hakemukset
			</Typography>
			<Typography variant="body1" color="text.secondary" paragraph>
				Hallinnoi ja tarkastele tekoälyn arvioimia
				TalentPool-hakemuksia. Klikkaa hakemusta nähdäksesi
				yksityiskohdat.
			</Typography>
			<TalentPoolApplicationsTable />
		</Box>
	);
};

export default TalentPoolApplications;
